import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useSavePlaylist = () => {
  const { onSubmit: handleSavePlaylist } = useFetch(
    'playlist-save',
    Api.PLAYLIST_CONTENTS
  );

  const onSavePlaylist = (id) => (values) =>
    handleSavePlaylist({
      body: values,
      pathParams: { id },
    });

  return {
    onSave: onSavePlaylist,
  };
};

export default useSavePlaylist;
